import LinearStat from '../../../elements/LinearStat/LinearStat';
import ViolationTooltip from './ViolationTooltip';
import { Tooltip, Typography } from '@mui/material';
import { AppCategory } from '../../applications-types';

const CategoryItem = ({ appName, category }: CategoryItemProps) => {
  return category.isNa ? (
    <Tooltip arrow title={category.reason.join('; ')}>
      <Typography
        sx={{
          verticalAlign: 'middle',
          display: 'inline-flex',
        }}
        variant='body2'
        color='text.secondary'>
        —
      </Typography>
    </Tooltip>
  ) : (
    <LinearStat
      total={category.total}
      severityScore={category.severityScore}
      tooltip={
        category.total ? (
          <ViolationTooltip category={category} appName={appName} />
        ) : undefined
      }
    />
  );
};

export interface CategoryItemProps {
  appName: string;
  category: AppCategory;
}

export default CategoryItem;
